module.exports = __webpack_public_path__ + "media/images/guide-4t-b39f0ccebbe7c27ea159a50844f35e0c.png";